import React, { useState, useMemo, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { db } from "../../firebase";
import { collection, doc, getDocs, setDoc,getDoc, onSnapshot,
  serverTimestamp,// ✅ AJOUT
 } from "firebase/firestore";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale ,DatePicker} from "react-datepicker";
import { fr } from "date-fns/locale/fr";
registerLocale("fr", fr);
const stripePromise = loadStripe('pk_live_51ND6ZkLg4uiaMuu2u948KSNhWfsnRv7F2QIIkLv8KNsLNzRaQHZR5c0GsB6jxKjCxM0157w8BuZIMq1EDJnIyCUq00Va8NbzTC');

const ReservationForm  = () => {
// const getDefaultReservationDate = () => {
//   const d = new Date();
//   d.setHours(0, 0, 0, 0);

//   if (d.getDay() === 1) {
//     d.setDate(d.getDate() + 1); // mardi
//   }
//   return d;
// };

// const getDefaultReservationDate = () => {
//   const d = new Date();
//   d.setHours(0, 0, 0, 0);
//   return d;
// };
// Récupère la date et l'heure françaises
const getParisDateTime = () => {
  const parts = new Intl.DateTimeFormat("fr-FR", {
    timeZone: "Europe/Paris",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date());

  const values = Object.fromEntries(
    parts
      .filter(({ type }) => type !== "literal")
      .map(({ type, value }) => [type, value])
  );

  const year = Number(values.year);
  const month = Number(values.month);
  const day = Number(values.day);
  const hour = Number(values.hour);
  const minute = Number(values.minute);

  const dayOfWeek = new Date(
    Date.UTC(year, month - 1, day)
  ).getUTCDay();

  return {
    year,
    month,
    day,
    hour,
    minute,
    dayOfWeek,
  };
};

// Samedi : fermeture à 18h30
// Tous les autres jours : fermeture à 20h30
const getSameDayCutoffMinutes = (dayOfWeek) => {
  return dayOfWeek === 6
    ? 18 * 60 + 30
    : 20 * 60 + 30;
};

// Vérifie si les réservations pour aujourd'hui sont fermées
const isSameDayReservationClosed = (selectedDate) => {
  if (!selectedDate) return false;

  const parisNow = getParisDateTime();

  const selectedIsToday =
    selectedDate.getFullYear() === parisNow.year &&
    selectedDate.getMonth() + 1 === parisNow.month &&
    selectedDate.getDate() === parisNow.day;

  if (!selectedIsToday) return false;

  const currentMinutes =
    parisNow.hour * 60 + parisNow.minute;

  const cutoffMinutes =
    getSameDayCutoffMinutes(parisNow.dayOfWeek);

  return currentMinutes >= cutoffMinutes;
};

// Date sélectionnée par défaut
const getDefaultReservationDate = () => {
  const parisNow = getParisDateTime();

  const d = new Date(
    parisNow.year,
    parisNow.month - 1,
    parisNow.day
  );

  const currentMinutes =
    parisNow.hour * 60 + parisNow.minute;

  const cutoffMinutes =
    getSameDayCutoffMinutes(parisNow.dayOfWeek);

  // Après l'heure limite, sélectionner automatiquement demain
  if (currentMinutes >= cutoffMinutes) {
    d.setDate(d.getDate() + 1);
  }

  // Si la date obtenue est un lundi,
  // passer automatiquement au mardi
  if (d.getDay() === 1) {
    d.setDate(d.getDate() + 1);
  }

  d.setHours(0, 0, 0, 0);

  return d;
}                                                                                                                                                                                   
  const [cardError, setCardError] = useState('');
// const [date, setDate] = useState(() => getDefaultReservationDate());
// const today = useMemo(() => getDefaultReservationDate(), []);
const [date, setDate] = useState(() => getDefaultReservationDate());

const minReservationDate = useMemo(
  () => getDefaultReservationDate(),
  []
);
  const [radioAnniv, setRadioAnniv] = useState("non"); 
  const [showFermetureModal, setShowFermetureModal] = useState(false);
  const [horaire, setHoraire] = useState("");
  const [horaireSpecial, setHoraireSpecial] = useState("");
  const [service, setService] = useState("");
  const [nbPersonnes, setNbPersonnes] = useState(1);
  const [typeGateau, setTypeGateau] = useState("");
  const [nbFraises, setNbFraises] = useState("");
  const [nbChocolat, setNbChocolat] = useState("");
  const [nom, setNom] = useState("");
  const [age, setAge] = useState("");
  const [tele, setTele] = useState("");
  const [messageGateau, setMessageGateau] = useState("");
  const [email, setEmail] = useState("");
  const [notification, setNotification] = useState({ visible: false, message: '' });

  // champs heures (type=time)
 const [hourJourn12_14, setHourJourn12_14] = useState("");
  const [minuteJourn12_14, setMinuteJourn12_14] = useState("");

  const [hourJourn9_18, setHourJourn9_18] = useState("");
  const [minuteJourn9_18, setMinuteJourn9_18] = useState("");

  const [hourSoiree18_22, setHourSoiree18_22] = useState("");
  const [minuteSoiree18_22, setMinuteSoiree18_22] = useState("");

  const [hourDim, setHourDim] = useState("");
  const [minuteDim, setMinuteDim] = useState("");

  const [hourServ1, setHourServ1] = useState("");
  const [minuteServ1, setMinuteServ1] = useState("");

  const [hourServ2, setHourServ2] = useState("");
  const [minuteServ2, setMinuteServ2] = useState("");

const [isSubmitting, setIsSubmitting] = useState(false);



  const stripe = useStripe();
const elements = useElements();

  // jour sélectionné (abréviation Su, Sa, Fr, ...)
  const dayAbbr = useMemo(() => { 
  if (!date) return null;
  const map = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  return map[date.getDay()]; 
}, [date]);

  const isSunday = dayAbbr === "Su";
  const isSaturday = dayAbbr === "Sa";
  const isFriday = dayAbbr === "Fr";

// Plus d'horaires spéciaux vendredi / samedi
const showHoraireSpecial = false;

// Lundi à vendredi : 12h-14h / 18h-22h
const showHoraireSemaine = !isSaturday && !isSunday;

const showTimeJourn12_14 = horaire === "Journée";
const showTimeSoiree18_22 = horaire === "Soirée";

// Ancien système spécial désactivé
const showTimeServices = false;
const showTimeService1 = false;
const showTimeService2 = false;

// Samedi et dimanche : 09h-22h
const showTimeDimWide = isSaturday || isSunday;

const showTimeVendSamJourn = false;
  const sousTotal = nbPersonnes * 5;

  // ---- nouvelle règle : montrer "Anniversaire" seulement si nbPersonnes>4 ET date >= today + 2 jours
   const dateIsAtLeastDaysFromToday = (dateObj, days) => {
  if (!dateObj) return false;

  const selected = new Date(dateObj); // dateObj déjà un Date → ok
  selected.setHours(0, 0, 0, 0);

  const min = new Date();
  min.setHours(0, 0, 0, 0);
  min.setDate(min.getDate() + days);

  return selected >= min;
};

  const showAnniversaire = Number(nbPersonnes) > 4 && dateIsAtLeastDaysFromToday(date, 2);
   const isValentinesDay =
    date &&
    date.getFullYear() === 2026 &&
    date.getMonth() === 1 && // Février = 1
    date.getDate() === 14;

  const requiresDeposit =
    ((showAnniversaire && radioAnniv === "oui") ||
      Number(nbPersonnes) > 9 ||
      (isValentinesDay && Number(nbPersonnes) >= 2));

  

  // si la condition d'affichage de l'anniversaire devient fausse, reset des champs anniversaire
  useEffect(() => {
    if (!showAnniversaire) {
      setRadioAnniv("non");
      // setTypeGateau("");
      // setNbFraises("");
      // setNbChocolat("");
      // setNom("");
      // setAge("");
      // setTele("");
      // setMessageGateau("");
      // setEmail("");
    }
  }, [showAnniversaire]);

useEffect(() => {
  
  const ref = doc(db, "metadata", "ferme");

  const unsub = onSnapshot(
    ref,
    (snap) => {
      const data = snap.exists() ? snap.data() : null;
      const isClosed = data?.ferme === true; 
      setShowFermetureModal(isClosed);
    },
    (err) => {
      console.error("Erreur listener fermeture:", err);
      
      setShowFermetureModal(false);
    }
  );

  return () => unsub();
}, []);


const calculateTotal = () => {
  return Number(nbPersonnes) * 5; // 5€ par personne
};

  const getEmailContent = async (id) => {
        try {
            const emailDoc = await getDoc(doc(db, 'email', id));
            if (emailDoc.exists()) {
                return emailDoc.data();
            } else {
                console.error('Document email non trouvé');
                return '';
            }
        } catch (error) {
            console.error('Erreur lors de la récupération de l\'email:', error);
            return '';
        }
    };

    const getClientPaymentMessage = (status) => {
  switch (status) {
    case "requires_action":
      return "Votre banque demande une validation supplémentaire. Merci de confirmer le paiement pour finaliser votre réservation.";
    case "requires_payment_method":
      return "Votre paiement a été refusé. Merci de vérifier votre carte ou d’utiliser un autre moyen de paiement.";
    case "processing":
      return "Votre paiement est en cours de traitement. Merci de patienter quelques instants avant de réessayer.";
    case "canceled":
      return "Le paiement a été annulé. Votre réservation n’a pas été enregistrée.";
    default:
      return "Le paiement n’a pas pu être validé. Merci de vérifier vos informations bancaires ou de réessayer.";
  }
};

const handleSubmit = async (e) => {
  e.preventDefault();
   if (isSubmitting) return;          // anti double-clic
  setIsSubmitting(true);             // lock
  setCardError("");

  let time12_14 = "";
if (hourJourn12_14 && minuteJourn12_14) {
  time12_14 = `${hourJourn12_14.toString().padStart(2,"0")}:${minuteJourn12_14.toString().padStart(2,"0")}`;
}

let time9_18 = "";
if (hourJourn9_18 && minuteJourn9_18) {
  time9_18 = `${hourJourn9_18.toString().padStart(2,"0")}:${minuteJourn9_18.toString().padStart(2,"0")}`;
}

let time18_22 = "";
if (hourSoiree18_22 && minuteSoiree18_22) {
  time18_22 = `${hourSoiree18_22.toString().padStart(2,"0")}:${minuteSoiree18_22.toString().padStart(2,"0")}`;
}

let timeDim = "";
if (hourDim && minuteDim) {
  timeDim = `${hourDim.toString().padStart(2,"0")}:${minuteDim.toString().padStart(2,"0")}`;
}

let timeServ1 = "";
if (hourServ1 && minuteServ1) {
  timeServ1 = `${hourServ1.toString().padStart(2,"0")}:${minuteServ1.toString().padStart(2,"0")}`;
}

let timeServ2 = "";
if (hourServ2 && minuteServ2) {
  timeServ2 = `${hourServ2.toString().padStart(2,"0")}:${minuteServ2.toString().padStart(2,"0")}`;
}


  try {
     // Déterminer l'heure choisie
    let heureChoisie = "";

    // Semaine lundi–jeudi
    if (showHoraireSemaine) {
      if (horaire === "Journée") {
        heureChoisie = time12_14;
      } 
      else if (horaire === "Soirée") {
        heureChoisie = time18_22;
      }
    }

   // Samedi / Dimanche
else if (isSaturday || isSunday) {
  heureChoisie = timeDim;
}

    // Vendredi / Samedi
    else if (showHoraireSpecial) {
      if (horaireSpecial === "Journée") {
        heureChoisie = time9_18;
      } 
      else if (horaireSpecial === "Soirée") {
        if (service === "service1") heureChoisie = timeServ1;
        if (service === "service2") heureChoisie = timeServ2;
      }
    }

   // Sécurité : aucune réservation le lundi
if (date && date.getDay() === 1) {
  alert(
    "Le restaurant est fermé le lundi. Merci de choisir une autre date."
  );
  return;
}

// Sécurité : empêcher une réservation le jour même après l'heure limite
if (isSameDayReservationClosed(date)) {
  const cutoffLabel =
    date.getDay() === 6 ? "18h30" : "20h30";

  alert(
    `Les réservations pour aujourd'hui sont fermées à partir de ${cutoffLabel}. Merci de choisir une autre date.`
  );

  return;
}
  const dateFr = `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth()+1).toString().padStart(2, "0")}-${date.getFullYear()}`;
    // ✅ AJOUT : date de création (aujourd'hui) format FR
          const now = new Date();
          const createdAt = `${now.getDate().toString().padStart(2, "0")}-${(now.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${now.getFullYear()}`;

// Vérification des champs obligatoires

if (!date) {
  alert("Merci de sélectionner une date de réservation.");
  return;
}

if (showHoraireSemaine && !horaire) {
  alert("Merci de sélectionner une plage horaire : Journée ou Soirée.");
  return;
}

if (showHoraireSpecial && !horaireSpecial) {
  alert("Merci de sélectionner une plage horaire : Journée ou Soirée.");
  return;
}

if (
  showHoraireSpecial &&
  horaireSpecial === "Soirée" &&
  !service
) {
  alert("Merci de sélectionner un service.");
  return;
}

if (!heureChoisie) {
  alert("Merci de sélectionner une heure complète de réservation.");
  return;
}

if (!nom) {
  alert("Merci de renseigner votre nom.");
  return;
}

if (!tele) {
  alert("Merci de renseigner votre numéro de téléphone.");
  return;
}

if (!email) {
  alert("Merci de renseigner votre adresse e-mail.");
  return;
}

if (!nbPersonnes) {
  alert("Merci de renseigner le nombre de personnes.");
  return;
}
    let prestation = 0; // valeur par défaut si tu veux
    if (
      parseInt(nbPersonnes) > 9 ||
      (parseInt(nbPersonnes) > 4 && radioAnniv === "oui") ||
      (isValentinesDay && parseInt(nbPersonnes) >= 2)
    ) {
      prestation = 5 * nbPersonnes;
    } else {
      prestation = 0;
    }

    // --- 1️⃣ Récupérer le dernier ID utilisé ---
    const reservationRef = collection(db, "reservation");
    const snapshot = await getDocs(reservationRef);
    let maxId = 0;
    snapshot.forEach((docSnap) => {
      const data = docSnap.data();
      if (data && data.id && !isNaN(data.id)) {
        maxId = Math.max(maxId, parseInt(data.id));
      }
    });
    const newId = String(maxId + 1); // ID incrémental en string

    // --- 2️⃣ Créer l'objet réservation ---
    const isAnniv = radioAnniv === "oui";

    const newReservation = {
      id: newId,
      docId: newId,
       createdAt,
      nom,
      tele,
      email,
      date: dateFr,
      heure: heureChoisie,
      nbrPersonne: nbPersonnes.toString(),
      ageP: isAnniv ? (age ? age.toString() : "") : "",
      anniv: radioAnniv,
      texteGateau: isAnniv ? (messageGateau || "") : "",
      typeGateau: isAnniv ? (typeGateau || "") : "",
      nbFraises: isAnniv ? (nbFraises || 0) : 0,
      nbChocolat: isAnniv ? (nbChocolat || 0) : 0,
      prestation,
      statut: "soumis",
      createWith: "client"
    };



    // === Paiement Stripe si anniversaire ou > 9 personnes ===
    if (requiresDeposit || Number(nbPersonnes) > 9) {
      if (!stripe || !elements) {
        setCardError("Erreur avec Stripe. Merci de recharger la page.");
        return;
      }

      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        setCardError("Veuillez renseigner vos informations de carte.");
        return;
      }

      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: newReservation.nom,
          email: newReservation.email,
          phone: newReservation.tele
        }
      });

      if (error) {
        setCardError(error.message);
        return;
      }

      setCardError('');
      // Appel à ton backend pour effectuer le paiement
      const response = await fetch("https://api-7zyk3qftka-uc.a.run.app/api/payment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          paymentMethodId: paymentMethod.id,
          amount: Math.round(calculateTotal() * 100),
        }),
      });

      const data = await response.json();

    
let paymentIntentStatus = data.status;

if (data.status === "requires_action") {
  if (!data.clientSecret) {
    setCardError("Une validation bancaire est nécessaire, mais une erreur est survenue. Merci de réessayer.");
    return;
  }

  const result = await stripe.confirmCardPayment(data.clientSecret);

  if (result.error) {
    setCardError(result.error.message || "Validation bancaire échouée.");
    return;
  }

  paymentIntentStatus = result.paymentIntent.status;
}

if (paymentIntentStatus !== "succeeded") {
   setCardError(getClientPaymentMessage(paymentIntentStatus));
  return;
}

console.log("Paiement réussi");
    }

    // === Enregistrer la réservation dans Firestore avec ID incrémental ===
    const docRef = doc(db, "reservation", newId);
    await setDoc(docRef, newReservation);

 setNotification({
        visible: true,
       
      });
      setTimeout(() => setNotification({ visible: false }), 5000);

      // Réinitialiser le formulaire
   setDate(getDefaultReservationDate());           
    setHoraire("");
    setHoraireSpecial("");
    setService("");

    setHourJourn12_14("");
    setMinuteJourn12_14("");

    setHourJourn9_18("");
    setMinuteJourn9_18("");

    setHourSoiree18_22("");
    setMinuteSoiree18_22("");

    setHourDim("");
    setMinuteDim("");

    setHourServ1("");
    setMinuteServ1("");

    setNom("");
    setTele("");
    setEmail("");
    setNbPersonnes(1);
    setRadioAnniv("non");
    setTypeGateau("");
    setNbFraises("");
    setNbChocolat("");
    setAge("");
    setMessageGateau("");
    const cardElement = elements.getElement(CardElement);
    if (cardElement) cardElement.clear();

    console.log("Réservation ajoutée");
        let emailContent;
      if (parseInt(nbPersonnes) > 4 && radioAnniv === "oui") {
              emailContent = await getEmailContent('confirmation_res_anniv');
          } else {
              emailContent = await getEmailContent('confirmation_res_simple');
          }
    
    
      const emailResponse = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/email-reservation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id:newReservation.id,
                email: newReservation.email,
                nom: newReservation.nom,
                date: newReservation.date,
                heure: newReservation.heure,
                nbrPersonne: newReservation.nbrPersonne,
                anniv: newReservation.anniv,
                typeGateau: newReservation.typeGateau,
                texteGateau: newReservation.texteGateau,
                ageP: newReservation.ageP,
                prestation: newReservation.prestation,
                objet:emailContent.objet || "",
                emailContent1:emailContent.texte || "",
                emailContent2:emailContent.texte2 || "",

            }),
        });

  
  } catch (error) {
    console.error("Erreur lors de la soumission :", error);
  }finally {
    setIsSubmitting(false);
  }
};




  return (
    <div className="container d-flex align-items-center justify-content-center mt-5">
 
           <div>
                
                {/* Votre composant principal */}
            </div>
        <div className="col-11 ">
            <div className="banner-section banner-acc mb-4">
                <div className="banner-content d-flex align-items-center justify-content-start">
                    <h2 className="tl-banner">Réserver votre table</h2>
                </div>
            </div>
           {notification.visible && (
            <div className="notification-success mt-3">
  <div className="notif-icon">✔</div>

  <div className="notif-content">
    <div className="notif-title">Demande de réservation envoyée</div>

    <div className="notif-text">
      <strong>⚠️ Ceci n’est pas encore une confirmation!</strong><br />
      Votre demande de réservation a bien été reçue et est actuellement en attente de validation par le restaurant.<br />
      Vous recevrez une confirmation ou un refus par e-mail. Merci de vérifier votre boîte mail.
    </div>
  </div>
</div>
          )}
     <Form className="form-resrv" onSubmit={handleSubmit} >
       <fieldset disabled={isSubmitting}>
                     <Row>
                     {/* COLONNE GAUCHE */}
                     <Col md={6}>
                         <Form.Group className="mb-3">
                         <Form.Label>À quelle date souhaitez-vous venir (Il est obligatoire de réserver avant 2 jours pour une réservation pour un anniversaire) <span>*</span></Form.Label>
                          <DatePicker
                            selected={date}
                            onChange={(d) => setDate(d)}
                            minDate={minReservationDate}
                            filterDate={(selectedDate) => {
                              // Bloquer tous les lundis
                              if (selectedDate.getDay() === 1) {
                                return false;
                              }

                              // Bloquer également aujourd'hui après l'heure limite
                              return !isSameDayReservationClosed(selectedDate);
                            }}
                            placeholderText="Sélectionnez une date"
                            className="form-control datepicker"
                            dateFormat="dd/MM/yyyy"
                            locale="fr"
                            calendarStartDay={1}
                            showPopperArrow={false}
                          />
                       
                         </Form.Group>
                         {/* Horaire global radio-2 */}
                         {showHoraireSemaine && (
                             <Form.Group className="mb-3">
                             <Form.Label>Plage d'horaire</Form.Label>
                             <div>
                                 <Form.Check
                                 inline
                                 type="radio"
                                 label="Journée"
                                 name="horaire"
                                 checked={horaire === "Journée"}
                                 onChange={() => setHoraire("Journée")}
                                 />
                                 <Form.Check
                                 inline
                                 type="radio"
                                 label="Soirée"
                                 name="horaire"
                                 checked={horaire === "Soirée"}
                                 onChange={() => setHoraire("Soirée")}
                                 />
                             </div>
                             {/* (lundi-jeudi */}
                             </Form.Group>
                         )}
                         {/* Heures as time inputs */}
                         {showHoraireSemaine && showTimeJourn12_14 && (
                          <Form.Group className="mb-3">
                           <Form.Label>À quelle heure souhaitez-vous venir</Form.Label>
                           <Row>
                             <Col>
                               <Form.Select
                                 required
                                 value={hourJourn12_14}
                                 onChange={(e) => setHourJourn12_14(e.target.value)}
                               >
                                 <option value="">HH</option>
                                 {[12, 13, 14].map((h) => (
                                   <option key={h} value={h}>
                                     {h.toString().padStart(2, "0")} H
                                   </option>
                                 ))}
                               </Form.Select>
                             </Col>
                             <Col>
                               <Form.Select
                                 required
                                 value={minuteJourn12_14}
                                 onChange={(e) => setMinuteJourn12_14(e.target.value)}
                               >
                                 <option value="">MM</option>
                                 {Array.from({ length: 4 }, (_, i) => i * 15)
                                   .filter((m) => {
                                     if (hourJourn12_14 === "14") return m === 0; // 14:00 max
                                     return true; // 12 & 13 → toutes les minutes
                                   })
                                   .map((m) => (
                                     <option key={m} value={m.toString().padStart(2, "0")}>
                                       {m.toString().padStart(2, "0")} Min
                                     </option>
                                   ))}
                               </Form.Select>
                             </Col>
     
                           </Row>
                         </Form.Group>
     
                         )}
     
                        {showHoraireSemaine && showTimeSoiree18_22 && (
                           <Form.Group className="mb-3">
                             <Form.Label>À quelle heure souhaitez-vous venir</Form.Label>
                             <Row>
                               <Col>
                                 <Form.Select
                                   required
                                   value={hourSoiree18_22}
                                   onChange={(e) => setHourSoiree18_22(e.target.value)}
                                 >
                                   <option value="">HH</option>
                                   {[18,19,20,21,22].map(h => (
                                     <option key={h} value={h}>{h.toString().padStart(2,"0")} H</option>
                                   ))}
                                 </Form.Select>
                               </Col>
                               <Col>
                                 <Form.Select
                                   required
                                   value={minuteSoiree18_22}
                                   onChange={(e) => setMinuteSoiree18_22(e.target.value)}
                                 >
                                   <option value="">MM</option>
                                   {Array.from({ length: 4 }, (_, i) => i * 15)
                                     .filter((m) => {
                                       if (hourSoiree18_22 === "18") return m >= 30;     // 18:30 min
                                       if (hourSoiree18_22 === "22") return m <= 30;     // 22:30 max
                                       return true;                                     // 19–21
                                     })
                                     .map((m) => (
                                       <option key={m} value={m.toString().padStart(2, "0")}>
                                         {m.toString().padStart(2, "0")} Min
                                       </option>
                                     ))}
                                 </Form.Select>
                               </Col>
     
     
                             </Row>
                           </Form.Group>
                         )}
     
     
                     
                         {showTimeDimWide && (
                         <Form.Group className="mb-3">
                             <Form.Label>À quelle heure souhaitez-vous venir</Form.Label>
                           <Row>
                             <Col>
                               <Form.Select
                                 required
                                 value={hourDim}
                                 onChange={(e) => setHourDim(e.target.value)}
                               >
                                 <option value="">HH</option>
                                 {Array.from({ length: 22 - 9 + 1 }, (_, i) => i + 9).map((h) => (
                                   <option key={h} value={h}>{h.toString().padStart(2,"0")} H</option>
                                 ))}
                               </Form.Select>
                             </Col>
                             <Col>
                               <Form.Select
                                 required
                                 value={minuteDim}
                                 onChange={(e) => setMinuteDim(e.target.value)}
                               >
                                 <option value="">MM</option>
                                    {/* Minutes avec step 5, mais limitées à 30 si heure = 22 */}
                                     {Array.from({ length: 4 }, (_, i) => i * 15)
                                       .filter((m) => {
                                         if (hourDim === "22") return m <= 30; // limite 22:30
                                         return true;
                                       })
                                       .map((m) => (
                                         <option key={m} value={m.toString().padStart(2, "0")}>
                                           {m.toString().padStart(2, "0")} Min
                                         </option>
                                       ))}
                               </Form.Select>
                             </Col>
                           </Row>
     
                            {/* Dimanche : 09:00 - 22:30 */}
                         </Form.Group>
                         )}
     
     
                         {showHoraireSpecial && (
                         <Form.Group className="mb-3">
                             <Form.Label>Plage d'horaire </Form.Label>
                             <div>
                             <Form.Check
                                 inline
                                 type="radio"
                                 label="Journée"
                                 name="horaireSpecial"
                                 checked={horaireSpecial === "Journée"}
                                 onChange={() => setHoraireSpecial("Journée")}
                             />
                             <Form.Check
                                 inline
                                 type="radio"
                                 label="Soirée"
                                 name="horaireSpecial"
                                 checked={horaireSpecial === "Soirée"}
                                 onChange={() => setHoraireSpecial("Soirée")}
                             />
                             </div>
                             {/* (Vendredi / Samedi) */}
                         </Form.Group>
                         )}
                            {showHoraireSpecial && showTimeVendSamJourn && (
                         <Form.Group className="mb-3">
                       
                            {/* Vend/Sam Journée: 09:00 - 18:00 */}
                           <Row>
                             <Col>
                               <Form.Select
                                 required
                                 value={hourJourn9_18}
                                 onChange={(e) => setHourJourn9_18(e.target.value)}
                               >
                                 <option value="">HH</option>
                                 {Array.from({ length: 18 - 9 + 1 }, (_, i) => i + 9).map((h) => (
     
                                   <option key={h} value={h}>
                                     {h.toString().padStart(2, "0")} H
                                   </option>
                                 ))}
                               </Form.Select>
                             </Col>
                           
                             <Col>
                               <Form.Select
                                 required
                                 value={minuteJourn9_18}
                                 onChange={(e) => setMinuteJourn9_18(e.target.value)}
                               >
                                 <option value="">MM</option>
                                 {Array.from({ length: 4 }, (_, i) => i * 15)
                                   .filter((m) => {
                                     if (hourJourn9_18 === "18") return m === 0; 
                                     return true; // 12 & 13 → toutes les minutes
                                   })
                                   .map((m) => (
                                     <option key={m} value={m.toString().padStart(2, "0")}>
                                       {m.toString().padStart(2, "0")} Min
                                     </option>
                                   ))}
                               </Form.Select>
                             </Col>
     
                           </Row>
                          </Form.Group>
                         )}
                         {showHoraireSpecial && showTimeServices && (
                         <Form.Group className="mb-3">
                         <Form.Label>Quel service choisissez-vous?</Form.Label>
                         <div>
                             <Form.Check
                             inline
                             type="radio"
                             label="18h30 max 19h30 quitter les tables à 21h"
                             name="service"
                             checked={service === "service1"}
                             onChange={() => setService("service1")}
                             />
                             <Form.Check
                             inline
                             type="radio"
                             label="21h15 max 22h quitter les tables à 23h30"
                             name="service"
                             checked={service === "service2"}
                             onChange={() => setService("service2")}
                             />
                         </div>
                         </Form.Group>
                         )}
                         {showHoraireSpecial && showTimeServices && showTimeService1 && (
                         <Form.Group className="mb-3">
                         <Form.Label>À quelle heure souhaitez-vous venir </Form.Label>
                         <Row>
                           <Col>
                             <Form.Select
                               required
                               value={hourServ1}
                               onChange={(e) => setHourServ1(e.target.value)}
                             >
                               <option value="">HH</option>
                               {[18,19,20].map(h => (
                                 <option key={h} value={h}>{h.toString().padStart(2,"0")} H</option>
                               ))}
                             </Form.Select>
                           </Col>
                           <Col>
                             <Form.Select
                               required
                               value={minuteServ1}
                               onChange={(e) => setMinuteServ1(e.target.value)}
                             >
                               <option value="">MM</option>
                                  {Array.from({ length: 4 }, (_, i) => i * 15)
                                   .filter((m) => {
                                     if (hourServ1 === "20") return m == 0;   // maximum 19:30
                                     if (hourServ1 === "18") return m >= 30;   // minimum 18:30
                                     return true; // empêche les minutes si heure hors plage
                                   })
                                   .map((m) => (
                                     <option key={m} value={m.toString().padStart(2, "0")}>
                                       {m.toString().padStart(2, "0")} Min
                                     </option>
                                   ))}
     
                             </Form.Select>
                           </Col>
                         </Row>
     
                          {/* 18:30 - 19:30 */}
                         </Form.Group>
                         )}
                         {showHoraireSpecial && showTimeServices && showTimeService2 && (
                         <Form.Group className="mb-3">
                         <Form.Label>À quelle heure souhaitez-vous venir</Form.Label>
                         <Row>
                           <Col>
                             <Form.Select
                               required
                               value={hourServ2}
                               onChange={(e)=>setHourServ2(e.target.value)}
                             >
                               <option value="">HH</option>
                               {[21,22].map(h => (
                                 <option key={h} value={h}>{h.toString().padStart(2,"0")} H</option>
                               ))}
                             </Form.Select>
                           </Col>
                           <Col>
                             <Form.Select
                               required
                               value={minuteServ2}
                               onChange={(e)=>setMinuteServ2(e.target.value)}
                             >
                               <option value="">MM</option>
                                {Array.from({ length: 4 }, (_, i) => i * 15)
                                   .filter((m) => {
                                     if (hourServ2 === "21") return m >= 15;   
                                     if (hourServ2 === "22") return m <= 15;  
                                     return true; // empêche les minutes si heure hors plage
                                   })
                                   .map((m) => (
                                     <option key={m} value={m.toString().padStart(2, "0")}>
                                       {m.toString().padStart(2, "0")} Min
                                     </option>
                                   ))}
                             </Form.Select>
                           </Col>
                         </Row>
     
                          {/* 21:15 - 22:15 */}
                         </Form.Group>
                         )}
                                 <Form.Group className="mb-3">
                         <Form.Label>Nom <span>*</span></Form.Label>
                         <Form.Control required value={nom} name="name" autoComplete="name"  onChange={(e) => setNom(e.target.value)} placeholder="Ecrire votre nom"/>
                         </Form.Group>
                             <Form.Group className="mb-3">
                         <Form.Label>Téléphone <span>*</span></Form.Label>
                         <Form.Control required value={tele} name="tele" autoComplete="tele" onChange={(e) => setTele(e.target.value)} placeholder="Ecrire votre numéro de téléphone" />
                         </Form.Group>
                         <Form.Group className="mb-3">
                             <Form.Label>Adresse de messagerie <span>*</span></Form.Label>
                             <Form.Control required type="email"  name="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Ecrire votre adresse de messagerie"/>
                         </Form.Group>
                             {/* Paiement Stripe si anniversaire = oui et nbPersonnes > 9 */}
                         {(requiresDeposit || Number(nbPersonnes) > 9) && (
                             <Form.Group className="mb-3">
                               <Form.Label>Carte de Crédit</Form.Label>
                               <CardElement id="card" />
                               {cardError && <p style={{ color: 'red', marginTop: '10px' }}>{cardError}</p>}
                             </Form.Group>
                           )}
                       {(requiresDeposit || Number(nbPersonnes) > 9) && (
                         <div className="card-texte">
                           <p>Afin de finaliser votre réservation, nous vous demandons d'avancer 5€ par personne ({sousTotal.toFixed(2)} € au total). Merci de votre compréhension. 
                            <span> Le montant de la réservation sera déduit de la facture payée au restaurant.</span></p>
                         </div>
     
                       )}
                     </Col>
     
                     {/* COLONNE DROITE */}
                     <Col md={6}>
     
                             {/* NB personnes */}
                         <Form.Group className="mb-3">
                         <Form.Label>Combien de personnes êtes-vous?</Form.Label>
                         <Form.Control
                             type="number"
                             required
                             min={1}
                             name="nbPersonnes"
                             autoComplete="nbPersonnes"
                             value={nbPersonnes}
                             onChange={(e) => setNbPersonnes(Number(e.target.value))}
                         />
                         
                         </Form.Group>
                           {/* === SECTION ANNIVERSAIRE : visible uniquement si showAnniversaire === true === */}
                             {showAnniversaire && (
                         <>
                             <Form.Group className="mb-3">
                             <Form.Label>Souhaitez-vous faire une réservation pour un anniversaire?</Form.Label>
                             <div>
                                 <Form.Check
                                 inline
                                 type="radio"
                                 label="Oui"
                                 name="anniv"
                                 checked={radioAnniv === "oui"}
                                 onChange={() => setRadioAnniv("oui")}
                                 />
                                 <Form.Check
                                 inline
                                 type="radio"
                                 label="Non"
                                 name="anniv"
                                 checked={radioAnniv === "non"}
                                 onChange={() => setRadioAnniv("non")}
                                 />
                             </div>
                           
                             </Form.Group>
                         </>)}
     
                             
                         {showAnniversaire && (
                         <>
     
                             {radioAnniv === "oui" && (
                             <>
                                 <Form.Group className="mb-3">
                                 <Form.Label>Quel gâteau souhaitez-vous?</Form.Label>
                                 <Form.Select value={typeGateau} onChange={(e) => setTypeGateau(e.target.value)}>
                                     <option value="Chocolat (nutella pasta)">Chocolat (nutella pasta)</option>
                                     <option value="Fraisier">Fraisier</option>
                                     <option value="personnalise">Personnalisé</option>
                                 </Form.Select>
                                 </Form.Group>
     
                                 {typeGateau === "personnalise" && (
                                 <>
                                     <Form.Group className="mb-3">
                                     <Form.Label>Nombre de part à la fraise <span>*</span></Form.Label>
                                     <Form.Control
                                         type="number"
                                         min={4}
                                         value={nbFraises}
                                         required
                                         onChange={(e) => setNbFraises(e.target.value)}
                                     />
                                     </Form.Group>
     
                                     <Form.Group className="mb-3">
                                     <Form.Label>Nombre de part au chocolat <span>*</span></Form.Label>
                                     <Form.Control
                                         type="number"
                                         min={4}
                                         required
                                         value={nbChocolat}
                                         onChange={(e) => setNbChocolat(e.target.value)}
                                     />
                                     </Form.Group>
                                 </>
                                 )}
     
                     
     
                                 <Form.Group className="mb-3">
                                 <Form.Label>Quel âge aura la personne qui fête son anniversaire</Form.Label>
                                 <Form.Control
                                     type="number"
                                     min={0}
                                     value={age}
                                     name="age" autoComplete="age"
                                     onChange={(e) => setAge(e.target.value)}
                                 />
                                 </Form.Group>
     
                             
     
                                 <Form.Group className="mb-3">
                                 <Form.Label>Que souhaitez-vous dire pour personnaliser votre gâteau!</Form.Label>
                                 <Form.Control
                                     as="textarea"
                                     rows={2}
                                     value={messageGateau}
                                     name="messageGateau" autoComplete="messageGateau"
                                     onChange={(e) => setMessageGateau(e.target.value)}
                                     placeholder="Ecrire un message personnalisé"
                                 />
                                 </Form.Group>
                             </>
                             )}
                         </>
                         )}
                         
     
     
                     
                     </Col>
                     </Row>
                       {/* === TABLEAU RÉCAPITULATIF === */}
                      {(requiresDeposit || Number(nbPersonnes) > 9) && (
                         
                           <div className="mt-4">
                             <table className="table table-tva" style={{ borderColor: "#e0a96d" }}>
                               <thead style={{ color: "#000" }}>
                                 <tr>
                                   <th>Prestation</th>
                                   <th>Nombre de personnes</th>
                                   <th>Coût</th>
                                   <th>Sous Total</th>
                                 </tr>
                               </thead>
                               <tbody>
                                 <tr>
                                   <td><strong>Réservation</strong></td>
                                   <td>{nbPersonnes}</td>
                                   <td>4.17 €</td>
                                   <td>{(sousTotal / 1.2).toFixed(2)} €</td>
                                 </tr>
                                 <tr>
                                   <td></td>
                                   <td></td>
                                   <td><strong>TVA 20%</strong></td>
                                   <td>{(sousTotal - (sousTotal / 1.2)).toFixed(2)} €</td>
                                 </tr>
                                 <tr>
                                   <td></td>
                                   <td></td>
                                   <td><strong>Total</strong></td>
                                   <td><strong>{sousTotal.toFixed(2)} €</strong></td>
                                 </tr>
                               </tbody>
                             </table>
                           </div>
                             )}
     
                     <div className="card-submit">
                     <Button type="submit" className="submit-resr">{isSubmitting ? "Validation en cours..." : "Valider"}</Button>
                     </div>
                      </fieldset>
                 </Form>
           
        </div>

         {/* Modal de fermeture de restaurant */}
         <Modal show={showFermetureModal}   centered>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div>
              <h5 className="mb-2 modal-tl  p-4 text-center">Le restaurant est fermé</h5>
              <p className="text-muted modal-text"></p>
             
            </div>
          </Modal.Body>
        </Modal>
    </div>
  );
};

const Reservation = () => (
  <Elements stripe={stripePromise}>
    <ReservationForm />
  </Elements>
);
export default Reservation;